import React from 'react'
import { EmtTypography } from 'emt-components-v2'
import { usePetsitterPrice } from '@/hooks/usePetsitterPrice'
import { useNewRequestCartStore } from '@/store/newRequestCartStore'
import { formatPrice } from '@/utils/formatPrice'

interface PetsitterPriceProps {
  uuid: string
}

export const PetsitterPrice: React.FC<PetsitterPriceProps> = ({ uuid }) => {
  const cartPayload = useNewRequestCartStore((s) => s.getCartPayload())
  const petsToComplete = useNewRequestCartStore((s) => s.petsToComplete)
  const { petsitterPrice } = usePetsitterPrice({
    uuid,
    cartPayload,
    petsToComplete,
  })
  return (
    <EmtTypography variant="caption" sx={{ textAlign: 'center', color: '#A5A3A9' }}>
      <span style={{ whiteSpace: 'nowrap' }}>
        {petsitterPrice?.total ? `${formatPrice(petsitterPrice.total)} €` : ''}
      </span>
    </EmtTypography>
  )
}
